import Cookies from 'js-cookie'

const TokenKey = 'token'
// 获取token值
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
// 删除token值
export function removeToken() {
  return Cookies.remove(TokenKey)
}
const Account_type = 'account_type'
// 获取account_type值
export function getaccount_type() {
  return Cookies.get(Account_type)
}

export function setaccount_type(account_type) {
  return Cookies.set(Account_type, account_type)
}
// 删除account_type值
export function removeaccount_type() {
  return Cookies.remove(Account_type)
}
// 获取name值
const Name = 'name'
export function getname() {
  return Cookies.get(Name)
}
export function setname(name) {
  return Cookies.set(Name, name)
}
// 删除account_type值
export function removename() {
  return Cookies.remove(Name)
}
